import { api } from './index';
function index(communeId, distributorId) { let path = `/api/internal/gas_items/?commune_id=${communeId}`; if (distributorId) {
    path = `${path}&distributor_id=${distributorId}`;
} return api({ method: 'get', url: path }).then(response => { var _response$data; return (_response$data = response.data) == null ? void 0 : _response$data.gasItems; }); }
export { index };
